import { Phone, EnvelopeSimple, MapPin, ClockCounterClockwise } from "@phosphor-icons/react";
import ServiceForm from "@/components/ServiceForm";
import { CONTACT } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const LeadSection = ({ commercial = false, sourcePage = "home" }) => (
  <section id="request" data-testid="lead-section" className="relative border-t border-white/10 bg-panel/40 py-24 md:py-32">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-6 md:px-12 lg:grid-cols-[1fr_1.1fr]">
      <Reveal>
        <div className="mb-4 flex items-center gap-3">
          <span className="h-px w-10 bg-brand-cyan" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">{commercial ? "Project Review" : "Request Service"}</span>
        </div>
        <h2 className="font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
          {commercial ? "Discuss your commercial project." : "Tell us what your system is doing."}
        </h2>
        <p className="mt-6 max-w-md font-body text-base leading-relaxed text-slatex-300">
          Share the details and photos. We'll review your request and respond via your preferred contact method — clear scope, honest options.
        </p>

        <div className="mt-10 space-y-4">
          {[
            { i: <Phone size={18} weight="fill" />, l: "Call", v: CONTACT.phone, href: `tel:${CONTACT.phoneRaw}` },
            { i: <EnvelopeSimple size={18} weight="fill" />, l: "Email", v: CONTACT.email, href: `mailto:${CONTACT.email}` },
            { i: <MapPin size={18} weight="fill" />, l: "Area", v: `${CONTACT.location} · ${CONTACT.radius}` },
            { i: <ClockCounterClockwise size={18} weight="fill" />, l: "Response", v: "Same-day on service requests" },
          ].map((x) => (
            <div key={x.l} className="flex items-center gap-4 border border-white/10 bg-ink p-4">
              <span className="flex h-10 w-10 items-center justify-center border border-brand-cyan/40 bg-brand-cyan/10 text-brand-cyan">{x.i}</span>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-slatex-500">{x.l}</div>
                {x.href ? <a href={x.href} className="font-body text-sm text-white hover:text-brand-cyan">{x.v}</a> : <span className="font-body text-sm text-white">{x.v}</span>}
              </div>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <ServiceForm commercial={commercial} sourcePage={sourcePage} />
      </Reveal>
    </div>
  </section>
);

export default LeadSection;
